"use client";

import { memo } from "react";
import {
  useA2UIComponent,
  type A2UIComponentProps,
  type Types,
} from "@a2ui/react";
import { resolveEnum, renderChildren } from "./utils";

const JUSTIFY: Record<string, string> = {
  start: "justify-start",
  center: "justify-center",
  end: "justify-end",
  spaceBetween: "justify-between",
  spaceAround: "justify-around",
  spaceEvenly: "justify-evenly",
};

const ALIGN: Record<string, string> = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch",
};

export const BeeOSRow = memo(function BeeOSRow({
  node,
  surfaceId,
}: A2UIComponentProps<Types.RowNode>) {
  useA2UIComponent(node, surfaceId);
  const props = node.properties;
  const alignment = resolveEnum(props.alignment, "stretch");
  const distribution = resolveEnum(props.distribution, "start");
  const children = Array.isArray(props.children) ? props.children : [];

  const hostStyle: React.CSSProperties =
    node.weight !== undefined
      ? ({ "--weight": node.weight } as React.CSSProperties)
      : {};

  return (
    <div
      className="a2ui-row"
      data-alignment={alignment}
      data-distribution={distribution}
      style={hostStyle}
    >
      <div
        className={`flex flex-row gap-2 w-full min-h-full ${JUSTIFY[distribution] ?? "justify-start"} ${ALIGN[alignment] ?? "items-stretch"}`}
      >
        {renderChildren(children, surfaceId)}
      </div>
    </div>
  );
});
